<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<template v-slot:header>
						<i class="icon-pencil"></i> Site management settings
					</template>
					<b-card-body>
						<b-form>
							<b-form-group
								label="Office"
								label-for="Office"
								:label-cols="3"
								:horizontal="true">
								<multiselect @input="getOfficeSiteManagementSettings()" v-model="selectedOffice"
														 :options="officeList"
														 :close-on-select="false"
														 :searchable="true"
														 label="name"
														 placeholder="Pick a value"></multiselect>
							</b-form-group>

							<template v-if="selectedOffice !== null && faceMatchingSetting !== null">
								<b-form-group
									label="Face Matching"
									label-for="faceMatching"
									:label-cols="3"
									:horizontal="true">
									<b-form-select
										v-model="faceMatchingValue"
										:options="statusOptions"
										class="mb-3"
										value-field="value"
										text-field="name"
										@change="onFaceMatchingChange()"
									></b-form-select>
								</b-form-group>

								<b-form-group
									v-if="globalMatchingSetting !== null"
									label="Global Matching"
									label-for="globalMatching"
									:label-cols="3"
									:horizontal="true">
									<b-form-select
										v-model="globalMatchingValue"
										:options="statusOptions"
										:disabled="!faceMatchingEnabled"
										class="mb-1"
										value-field="value"
										text-field="name"
									></b-form-select>
									<small v-if="!faceMatchingEnabled" class="text-muted">
										Turn on Face Matching to configure Global Matching.
									</small>
								</b-form-group>

								<div class="form-actions">
									<b-button type="button" variant="success" @click="updateSiteManagementSettings()">Save</b-button>
								</div>
							</template>
						</b-form>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import toastService from "@/services/toastService";
	import officeService from "../../services/officeService";
	import Multiselect from 'vue-multiselect'
	import generalSettingsService from "@/services/generalSettingsService";

	const FACE_MATCHING_KEY_CODE = 'FACE_MATCHING_ENABLED';
	const GLOBAL_MATCHING_KEY_CODE = 'GLOBAL_MATCHING_ENABLED';

	export default {
		name: "SiteManagementGeneralSettings",
		components: {
			Multiselect
		},
		data: function () {
			return {
				officeList: [],
				selectedOffice: null,
				faceMatchingSetting: null,
				globalMatchingSetting: null,
				faceMatchingValue: 'false',
				globalMatchingValue: 'false',
				statusOptions: [
					{ value: 'true', name: 'On' },
					{ value: 'false', name: 'Off' }
				]
			}
		},
		computed: {
			faceMatchingEnabled() {
				return this.faceMatchingValue === 'true';
			}
		},
		methods: {
			resetSettings() {
				this.faceMatchingSetting = null;
				this.globalMatchingSetting = null;
				this.faceMatchingValue = 'false';
				this.globalMatchingValue = 'false';
			},
			getOfficeSiteManagementSettings() {
				this.resetSettings();
				if (this.selectedOffice == null) {
					return;
				}
				// The Site Management group id is DB-assigned (auto-increment), so we locate the
				// two settings by their stable key codes rather than a hard-coded group id.
				generalSettingsService.getGeneralSettings(
					{ officeId: this.selectedOffice.id },
					(data) => {
						this.faceMatchingSetting = data.find(d => d.generalSettingsKey.keyCode === FACE_MATCHING_KEY_CODE) || null;
						this.globalMatchingSetting = data.find(d => d.generalSettingsKey.keyCode === GLOBAL_MATCHING_KEY_CODE) || null;
						if (this.faceMatchingSetting === null) {
							toastService.showErrorToast("Site Management settings are not configured for this environment");
							return;
						}
						this.faceMatchingValue = this.faceMatchingSetting.generalSettingsKey.setValue === 'true' ? 'true' : 'false';
						this.globalMatchingValue = this.globalMatchingSetting && this.globalMatchingSetting.generalSettingsKey.setValue === 'true' ? 'true' : 'false';
						// Enforce PRD §4: Global Matching only applies when Face Matching is on.
						if (!this.faceMatchingEnabled) {
							this.globalMatchingValue = 'false';
						}
					},
					(e) => toastService.showErrorToast(e)
				);
			},
			onFaceMatchingChange() {
				// When Face Matching is turned off, Global Matching cannot be configured (forced off).
				if (!this.faceMatchingEnabled) {
					this.globalMatchingValue = 'false';
				}
			},
			buildSettingUnit(setting, value) {
				return {
					groupId: setting.groupId,
					keyId: setting.generalSettingsKey.id,
					keyCode: setting.generalSettingsKey.keyCode,
					setValue: value,
					officeGroupKeyId: setting.generalSettingsKey.officeGroupKeyId
				};
			},
			updateSiteManagementSettings() {
				if (this.selectedOffice == null || this.faceMatchingSetting === null) {
					return;
				}
				// Re-apply the gate at save time so stale state can never persist Global on while Face is off.
				if (!this.faceMatchingEnabled) {
					this.globalMatchingValue = 'false';
				}
				const settings = [this.buildSettingUnit(this.faceMatchingSetting, this.faceMatchingValue)];
				if (this.globalMatchingSetting !== null) {
					settings.push(this.buildSettingUnit(this.globalMatchingSetting, this.globalMatchingValue));
				}
				const data = {
					officeId: this.selectedOffice.id,
					groupId: this.faceMatchingSetting.groupId,
					settings: settings
				};
				generalSettingsService.updateGeneralSettingsOfAnOffice(
					data,
					() => toastService.showSuccessToast("Updated Successfully"),
					() => toastService.showErrorToast("Update failed")
				);
			}
		},
		mounted() {
			officeService.getOfficeList(r => {
				this.officeList = r;
			});
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
